import { render, staticRenderFns } from "./SoCCard.vue?vue&type=template&id=f5fba7b8&scoped=true"
import script from "./SoCCard.vue?vue&type=script&lang=js"
export * from "./SoCCard.vue?vue&type=script&lang=js"
import style0 from "./SoCCard.vue?vue&type=style&index=0&id=f5fba7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fba7b8",
  null
  
)

export default component.exports